import { render, staticRenderFns } from "./DashboardDictionary.vue?vue&type=template&id=3a5d595c&scoped=true"
import script from "./DashboardDictionary.vue?vue&type=script&lang=js"
export * from "./DashboardDictionary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5d595c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5d595c')) {
      api.createRecord('3a5d595c', component.options)
    } else {
      api.reload('3a5d595c', component.options)
    }
    module.hot.accept("./DashboardDictionary.vue?vue&type=template&id=3a5d595c&scoped=true", function () {
      api.rerender('3a5d595c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/DashboardDictionary.vue"
export default component.exports